import { b as __assign } from '../_tslib-6fadb982.js';
import 'qs';
import 'axios';
import 'jsonp';
import 'mathjs';
import 'moment';
import 'query-string';
var cookie = {
  setCookieV2: function setCookieV2(cookieOption) {
    if (!cookieOption.time) {
      cookieOption.time = 1.5 * 3600;
    }

    var exp = new Date();
    exp.setTime(exp.getTime() + cookieOption.time * 1000);
    cookieOption.value = encodeURIComponent(cookieOption.value);
    var hostname = cookieOption.domain ? cookieOption.domain : '.gaodun.com';
    document.cookie = cookieOption.key + '=' + cookieOption.value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
  },
  setCookie: function setCookie(key, value, time) {
    if (!time) {
      time = 1.5 * 3600;
    }

    var exp = new Date();
    exp.setTime(exp.getTime() + time * 1000);
    value = encodeURIComponent(value);
    var hostname = '.gaodun.com';
    document.cookie = key + '=' + value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
  },
  getCookie: function getCookie(name) {
    var arr;
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    arr = document.cookie.match(reg);

    if (arr) {
      return decodeURIComponent(arr[2]);
    } else {
      return '';
    }
  },
  delCookie: function delCookie(name) {
    this.setCookie(name, '', -1);
  }
};

var _Promise = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var _Promise$1 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var _Promise$2 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var _Promise$3 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var _Promise$4 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var GDUSERID = 'GDUSERID';
var USECLIENT = 'useClient';

var User =
/** @class */
function () {
  function User() {
    this.handleListener = this.listenter.bind(this);
    this.config = {
      isEmpty: function isEmpty() {},
      isSameUser: function isSameUser() {},
      isDifferentUser: function isDifferentUser() {},
      useClient: function useClient() {}
    };
    this.initEvent();
    this.listenter = this.listenter.bind(this);
  }

  User.prototype.init = function () {
    if (/\/login/.test(location.pathname)) {
      return;
    }

    var sUserID = sessionStorage.getItem(GDUSERID);
    var cUserID = cookie.getCookie(GDUSERID);
    var useClient = cookie.getCookie(USECLIENT);

    if (useClient === '0' && this.config.useClient) {
      this.config.useClient();
    }

    if (sUserID === null || cUserID === null) {
      this.config.isEmpty();
    } else if (sUserID === cUserID) {
      this.config.isSameUser();
    } else {
      this.config.isDifferentUser();
    }
  };

  User.prototype.listenter = function () {
    if (!document.hidden) {
      this.init();
    }
  };

  User.prototype.initEvent = function () {
    // let fn: Function | null = window.onfocus;
    // 为了解决同一个浏览器，拖出多个窗口的场景，需要使用window.onfocus使用
    // window.onfocus = () => {
    //     if (fn !== null) {
    //         fn();
    //     }
    //     this.listenter();
    // };
    window.removeEventListener('focus', this.handleListener);
    window.addEventListener('focus', this.handleListener);
  };

  User.prototype.removeListenter = function () {
    window.removeEventListener('focus', this.handleListener); // window.onfocus = null;
    //document.removeEventListener('visibilitychange', this.listenter)
  };

  User.prototype.setConfig = function (config) {
    this.config = __assign(__assign({}, this.config), config);
    this.init();
  };

  return User;
}();

var user = new User();
export default user;